import { get } from "./api";

export const getSubAccounts = (customer_id, date, vendorExpense, signal, params={}) => {
  const url = `/api/v2/customers/${customer_id}/detailsubaccounts/${date}/${vendorExpense}`;
  return get(url, params, false, signal, true);
};

export const getActualValues = (id, formattedDate, signal, params={}) => {
  const url = `/api/v2/customers/${id}/actualvalues/${formattedDate}/`;
  return get(url, params, false, signal, true);
};

export const getYtdAverages = (id, formattedDate, signal, params={}) => {
  const url = `/api/v2/customers/${id}/ytdaverage/${formattedDate}/`;
  return get(url, params, false, signal, true);
};

export const getForecasts = (id, formattedDate, signal, params={}) => {
  const url = `/api/v2/customers/${id}/detailforecasts/${formattedDate}/`;
  return get(url, params, false, signal, true);
};

export const getCashMovement = (id, formattedDate, signal) => {
  const url = `/api/v2/customers/${id}/cashmovement/${formattedDate}/`;
  return get(url, {}, false, signal, true);
};

export const getBalanceSheetOverview = (id, formattedDate, signal) => {
  const url = `/api/v2/customers/${id}/balancesheetoverview/${formattedDate}/`;
  return get(url, {}, false, signal, true);
};

export const getVendorBreakdown = (
  id,
  formattedDate,
  expenseType,
  params,
  signal
) => {
  const url = `/api/v2/customers/${id}/vendorbreakdown/${formattedDate}/${expenseType}`;
  return get(url, params, false, signal, true);
};

export const getTransactionBreakdown = (
  id,
  formattedDate,
  expenseType,
  vendorId,
  params,
  signal
) => {
  const url = `/api/v2/customers/${id}/transactionbreakdown/${formattedDate}/${expenseType}/${vendorId}`;
  return get(url, params, false, signal, true);
};
